import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import Button from '../../../components/Button';
import SidebarSectionWrapper from './SidebarSectionWrapper';
import { pagesText } from '../../../constants/pagesText';

const DocumentationHelper = () => (
  <SidebarSectionWrapper>
    <Stack direction="column" spacing={0.75}>
      <Stack direction="row" justifyContent="start">
        <Button
          component={Link}
          href="https://www.appcontrol.ai/faq"
          target="_blank"
          size="medium"
          variant="text"
          styles={{
            color: '#87C8E0',
            maxWidth: '145px',
          }}>
          {pagesText.documentation.faq}
        </Button>
      </Stack>
    </Stack>
  </SidebarSectionWrapper>
);

export default DocumentationHelper;
